var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonWeb2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 145.33 93.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:1.5px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{stroke:#020202;}.cls-1,.cls-2,.cls-3,.cls-7{stroke-linecap:round;}.cls-1,.cls-4,.cls-7{fill:none;}.cls-1,.cls-5,.cls-6,.cls-7,.cls-8{stroke-miterlimit:10;}.cls-11,.cls-2,.cls-9{fill:#010101;}.cls-12,.cls-3,.cls-10{fill:#e9e8e8;}.cls-13{fill:#fff;}.cls-14{fill:#daf0f7;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9,.cls-10{stroke-width:2px;}.cls-5{fill:#ff7387;}.cls-6{fill:#adff78;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 26.21,
    y: -25.84,
    width: 92.91,
    height: 144.99,
    transform: "translate(25.82 119.19) rotate(-89.85)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 24.68,
    y: 29.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 25.68,
    y: 30.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 20.68,
    y: 24.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.68,
    y: 25.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 20.68,
    y: 24.79,
    width: 97,
    height: 49,
    rx: 12,
    ry: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 21.68,
    y: 25.79,
    width: 95,
    height: 47,
    rx: 11,
    ry: 11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M33.68,76.98c0-33.5,45-34,45,0H33.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.68,76.98c0-33.5,45-34,45,0H33.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 56.18,
    cy: 34.98,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 56.18,
    cy: 34.98,
    r: 13.5
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M28.68,71.98c0-33.5,45-34,45,0H28.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.68,71.98c0-33.5,45-34,45,0H28.68Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-12",
    cx: 51.18,
    cy: 29.98,
    r: 14.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 51.18,
    cy: 29.98,
    r: 13.5
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M126.15,28.52c0,6.34-9.22,11.49-20.59,11.49-5.98,0-11.37-1.43-15.13-3.7l-4.46,1.95-3.18,1.39c-.67,.29-1.32-.42-.98-1.06l1.64-3.06,2.2-4.09c-.45-.93-.68-1.91-.68-2.92,0-6.35,9.22-11.49,20.59-11.49s20.59,5.14,20.59,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M98.78,62.15c0,4.15,6.04,7.52,13.48,7.52,3.78,0,7.2-.87,9.65-2.27,.17-.1,.36-.11,.54-.03l2.64,1.15,1.78,.78c.53,.23,1.06-.34,.79-.85l-.92-1.71-1.3-2.42c-.09-.16-.09-.36-.02-.53,.22-.53,.33-1.08,.33-1.64,0-4.16-6.04-7.52-13.48-7.52-7.44,0-13.48,3.37-13.48,7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.15,25.52c0,6.34-9.22,11.49-20.59,11.49-5.98,0-11.37-1.43-15.13-3.7l-4.46,1.95-2.07,.91c-1.03,.45-2.05-.65-1.52-1.65l1.07-1.99,2.2-4.09c-.45-.93-.68-1.91-.68-2.92,0-6.35,9.22-11.49,20.59-11.49s20.59,5.14,20.59,11.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M95.78,59.15c0,4.15,6.04,7.52,13.48,7.52,3.91,0,7.44-.94,9.91-2.42l2.92,1.28,1.13,.49c.75,.33,1.49-.48,1.1-1.2l-.58-1.09-1.44-2.68c.29-.61,.45-1.25,.45-1.91,0-4.16-6.04-7.52-13.48-7.52-7.44,0-13.48,3.37-13.48,7.52Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.12,
    y1: 20.48,
    x2: 112.36,
    y2: 20.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 90.41,
    y1: 25.79,
    x2: 115.08,
    y2: 25.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 93.12,
    y1: 30.79,
    x2: 112.36,
    y2: 30.79
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 102.74,
    y1: 56.12,
    x2: 115.08,
    y2: 56.12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 100.46,
    y1: 59.32,
    x2: 117.07,
    y2: 59.32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 102.74,
    y1: 62.58,
    x2: 115.08,
    y2: 62.58
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonWeb2);
export default __webpack_public_path__ + "static/media/person_web2.7ce68a15ff2c17e1b51d13288d8de07b.svg";
export { ForwardRef as ReactComponent };